import * as drugsData from '../../../../../config/data/';

const getRapidSequenceDrug = id => drugsData.rapidSequence.find(drug => drug.key === Number(id));

const getVasoactiveDrug = id => drugsData.vasoactive.find(drug => drug.key === Number(id));

const getMaintenanceDrug = id => drugsData.maintenance.find(drug => drug.key === Number(id));

export {
    getRapidSequenceDrug,
    getVasoactiveDrug,
    getMaintenanceDrug,
}